import { render, staticRenderFns } from "./MultiImageUpload.vue?vue&type=template&id=835ed4ec"
import script from "./MultiImageUpload.vue?vue&type=script&lang=js"
export * from "./MultiImageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports